import { PageTreeViewModel, type PageTreeState } from "@bundle/core";
import { useCallback, useSyncExternalStore } from "react";
import { useWorkspaceContext } from "../context/AppContext.tsx";
import { useOwned } from "./owned.ts";

/** The workspace's page tree view model (sidebar, Projects hub, Home, tabs), without subscribing. */
export function usePageTreeViewModel(): PageTreeViewModel {
  const { workspace } = useWorkspaceContext();
  const key = `pagetree:${workspace.wsId}:${workspace.state.meId}`;
  const create = useCallback(() => new PageTreeViewModel(workspace), [workspace]);
  return useOwned(key, create);
}

/** The page tree and its state. */
export function usePageTree(): { vm: PageTreeViewModel; state: PageTreeState } {
  const vm = usePageTreeViewModel();
  return { vm, state: useSyncExternalStore(vm.subscribe, vm.getSnapshot, vm.getSnapshot) };
}
